import { render } from "./LongDevsDesing.vue?vue&type=template&id=31077320&scoped=true"
import script from "./LongDevsDesing.vue?vue&type=script&lang=js"
export * from "./LongDevsDesing.vue?vue&type=script&lang=js"

import "./LongDevsDesing.vue?vue&type=style&index=0&id=31077320&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31077320"]])

export default __exports__